import { StyleSheet, Font } from '@react-pdf/renderer';
const fontFamily = 'Open Sans';

Font.register({
  family: 'Open Sans',
  fonts: [
    { src: 'https://cdn.jsdelivr.net/npm/open-sans-all@0.1.3/fonts/open-sans-regular.ttf' },
    { src: 'https://cdn.jsdelivr.net/npm/open-sans-all@0.1.3/fonts/open-sans-600.ttf', fontWeight: 600 },
  ],
});

const Styles = StyleSheet.create({
  page: {
    backgroundColor: '#FFFFFF',
    paddingTop: 20,
    paddingBottom: 30,
  },
  rowView: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
  },
  textXs: { fontSize: 10, fontFamily },
  textXsStrong: { fontSize: 10, fontFamily, fontWeight: 'bold' },
  textSm: { fontSize: 12, fontFamily },
  textSmStrong: { fontSize: 12, fontFamily, fontWeight: 'bold' },
  textMdStrong: { fontSize: 16, fontFamily, fontWeight: 'bold' },
  marginBottomSm: { marginBottom: 10 },
  flexColumn: {
    display: 'flex',
    flexDirection: 'column',
  },
  flexRow: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'nowrap',
  },
  flexRowBetween: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    flexWrap: 'nowrap',
    alignItems: 'center',
  },
  headerBar: {
    width: '100%',
    height: 'auto',
    position: 'absolute',
  },
  auditionHeader: {
    height: 60,
    width: '100%',
    backgroundColor: '#FFFFFF',
    position: 'absolute',
    top: 16,
    padding: 15,
    borderBottom: '1px solid #e5e5e5',
  },
  footerBar: {
    height: 25,
    width: '100%',
    position: 'absolute',
    bottom: 0,
  },
  fadedText: { color: '#a8a8a8' },
});

export default Styles;
